import React from 'react';
import AppLink from '../AppLink/AppLink';

export enum TemplateSectionModule {
  EVENT = 'event',
  EVENT_TEMPLATE = 'event_template',
}

type TemplateNameContentProps = {
  moduleType: string;
  isNew?: boolean;
  name?: string;
  url: string;
  onClick?: () => void;
};

export const TemplateNameContent = ({ moduleType, isNew, name, url, onClick }: TemplateNameContentProps) => {
  if (moduleType === TemplateSectionModule.EVENT_TEMPLATE) {
    return <AppLink to={url}>{name}</AppLink>;
  }

  if (isNew) {
    return <span>{name}</span>;
  }

  return (
    <AppLink to="#" onClick={onClick}>
      {name}
    </AppLink>
  );
};
